import { Pipe, PipeTransform } from '@angular/core';
import { ContractPaymentType } from '../../interfaces/contract';

@Pipe({
  name: 'contractPaymentType'
})
export class ContractPaymentTypePipe implements PipeTransform {

  transform(value: ContractPaymentType): string {
    const types = {
      [ContractPaymentType.LOOSE]: 'Avulso',
      [ContractPaymentType.RECURRENT]: 'Recorrente',
      [ContractPaymentType.MUTUAL]: 'Mútuo'
    }

    return types[value]
  }

}
